import { ModelDropdownKey } from "../components/common/DropDowns/TextToImageModelsDropdown/NewTextToImageModelsDropdown";

export const DEFAULT_STRUCTURE_REF_INFLUENCE = 0.75;
export const DEFAULT_TAILORED_MODEL_INFLUENCE = 0.8;

export const IMAGE_REFERENCE = {
	structure_ref_influence: DEFAULT_STRUCTURE_REF_INFLUENCE,
};

export const IMAGE_REFERENCE_DISABLED_MODELS: ModelDropdownKey[] = ["hd_2.2", "base_3.1"];

export const IMAGE_REFERENCE_CONFIGS = {
	steps: {
		fast: {
			min: 4,
			max: 20,
			default: 12,
		},
		not_fast: {
			min: 20,
			max: 50,
			default: 30,
		},
		fibo: {
			min: 35,
			max: 50,
			default: 50,
		},
		fibo_lite: {
			min: 8,
			max: 30,
			default: 8,
		},
	},
};

export const TG_PROMPT_INPUT_LIGHT_HEIGHT = 22;

export const MAX_SEED_VALUE = 2147483640;
